import { render, staticRenderFns } from "./payment-view.vue?vue&type=template&id=52ff2883"
import script from "./payment-view.vue?vue&type=script&lang=js"
export * from "./payment-view.vue?vue&type=script&lang=js"
import style0 from "./payment-view.vue?vue&type=style&index=0&id=52ff2883&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports